import {
  GIFTCODE_ADD,
  GIFTCODE_GENERIC_REQUEST,
  GIFTCODE_UNIQUE_REQUEST,
  GIFTCODE_VIP_REQUEST,
  GIFTCODE_OPEN_REQUEST,
  GIFTCODE_DETAIL,
  GIFTCODE_HISTORY,
  GIFTCODE_REQUEST,
  GIFTCODE_SEND,
  GIFTCODE_SHOW,
} from '../mutations_type.js'

import {
  GENERAL_GIFTCODE_API,
  GAME_GIFTCODE_API,
  VIP_GIFTCODE_API,
  OPEN_GIFTCODE_API,
  SEND_GIFTCODE_API,
  GIFTCODE_RECEIVED_API,
  GAME_HISTORY_API,
  GIFTCODE_ADD_API,
  SHOW_GIFTCODE_API,
  GIFTCODE_API,
} from '../../services/api/api.js'

import axios from 'axios'
import router from '@/router'
import { routerErrror } from '../../services/route-navigation'

const header = {
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
  },
}

const state = {
  giftcode: [],
  giftcode_generic: [],
  giftcode_unique: [],
  giftcode_vip: [],
  giftcode_open: [],
  giftcode_send: [],
  giftcode_add: [],
  giftcode_history: [],
  giftcode_received: [],
  giftcode_detail: [],
  giftcode_show: [],
}

const getters = {
  GIFTCODES: state => {
    return state.giftcode
  },
  GIFTCODE_GENERIC: state => {
    return state.giftcode_generic
  },
  GIFTCODE_UNIQUE: state => {
    return state.giftcode_unique
  },
  GIFTCODE_VIP: state => {
    return state.giftcode_vip
  },
  GIFTCODE_OPEN: state => {
    return state.giftcode_open
  },
  GIFTCODE_SEND: state => {
    return state.giftcode_send
  },
  GIFTCODE_ADD: state => {
    return state.giftcode_add
  },
  GIFTCODE_HISTORY: state => {
    return state.giftcode_history
  },
  GIFTCODE_DETAIL: state => {
    return state.giftcode_detail
  },
  GIFTCODE_SHOW: state => {
    return state.giftcode_show
  },
}

const mutations = {
  [GIFTCODE_REQUEST]: (state, payload) => {
    state.giftcode = payload
  },
  [GIFTCODE_GENERIC_REQUEST]: (state, payload) => {
    state.giftcode_generic = payload
  },
  [GIFTCODE_UNIQUE_REQUEST]: (state, payload) => {
    state.giftcode_unique = payload
  },
  [GIFTCODE_VIP_REQUEST]: (state, payload) => {
    state.giftcode_vip = payload
  },
  [GIFTCODE_OPEN_REQUEST]: (state, payload) => {
    state.giftcode_open = payload
  },
  [GIFTCODE_DETAIL]: (state, payload) => {
    state.giftcode_detail = payload
  },
  [GIFTCODE_SHOW]: (state, payload) => {
    state.giftcode_show = payload
  },
  [GIFTCODE_SEND]: (state, payload) => {
    state.giftcode_send = payload
  },
  [GIFTCODE_ADD]: (state, payload) => {
    state.giftcode_add = payload
  },
  [GIFTCODE_HISTORY]: (state, payload) => {
    state.giftcode_history = payload
  },
  giftcodeReceived(state, payload) {
    state.giftcode_received.push(payload)
  },
}

const actions = {
  [GIFTCODE_REQUEST]: ({ commit }) => {
    commit('loading_giftcode', true)
    axios
      .get(GIFTCODE_API)
      .then(response => {
        const data = response.data
        const giftcodes = data.data
        if (data.code === 0 && giftcodes) {
          commit('GIFTCODE_REQUEST', giftcodes)
          commit('loading_giftcode', false)
        }
      })
      .catch(err => {
        const data = err.response.data
        console.log('Lỗi lấy danh sách giftcode ưu tiên: ', data)
      })
  },
  [GIFTCODE_GENERIC_REQUEST]: ({ commit }, payload) => {
    commit('loading_generic', true)
    const game_id = payload.game_id
    axios
      .get(GENERAL_GIFTCODE_API.replace('{game_id}', game_id), header)
      .then(response => {
        const data = response.data
        const general_giftcode = data.data
        if (data.code === 0 && general_giftcode) {
          commit('GIFTCODE_GENERIC_REQUEST', general_giftcode)
          commit('loading_generic', false)
        }
      })
  },
  [GIFTCODE_UNIQUE_REQUEST]: ({ commit }, payload) => {
    commit('loading_unique', true)
    const game_id = payload.game_id
    axios
      .get(GAME_GIFTCODE_API.replace('{game_id}', game_id), header)
      .then(response => {
        const data = response.data
        const unique_giftcode = data.data
        if (data.code === 0 && unique_giftcode) {
          commit('GIFTCODE_UNIQUE_REQUEST', unique_giftcode)
          commit('loading_unique', false)
        }
      })
  },
  [GIFTCODE_VIP_REQUEST]: ({ commit }, payload) => {
    commit('loading_vip', true)
    const game_id = payload.game_id
    axios
      .get(VIP_GIFTCODE_API.replace('{game_id}', game_id), header)
      .then(response => {
        const data = response.data
        const vip_giftcode = data.data
        if (data.code === 0 && vip_giftcode) {
          commit('GIFTCODE_VIP_REQUEST', vip_giftcode)
          commit('loading_vip', false)
        }
      })
  },
  [GIFTCODE_OPEN_REQUEST]: ({ commit }, payload) => {
    commit('loading_open', true)
    const game_id = payload.game_id
    axios
      .get(OPEN_GIFTCODE_API.replace('{game_id}', game_id), header)
      .then(response => {
        const data = response.data
        const open_giftcode = data.data
        if (data.code === 0 && open_giftcode) {
          commit('GIFTCODE_OPEN_REQUEST', open_giftcode)
          commit('loading_open', false)
        }
      })
  },
  [GIFTCODE_SEND]: ({ commit }, payload) => {
    commit('loading_dialog', true)
    const evid = payload.evid
    const puid = payload.puid
    axios
      .get(
        SEND_GIFTCODE_API.replace('{event_id}', evid).replace('{puid}', puid),
        header
      )
      .then(response => {
        const data = response.data
        const giftcodes = data.data
        if (data.code === 0 && giftcodes) {
          commit('GIFTCODE_DETAIL', giftcodes)
          commit('loading_dialog', false)
        }
      })
      .catch(err => {
        const data = err.response.data
        console.log('Lỗi gửi giftcode lên server: ', data)
      })
  },
  [GIFTCODE_ADD]: ({ commit }, payload) => {
    const { game_id, server_id, character_id, code } = payload
    axios
      .post(
        GIFTCODE_ADD_API,
        {
          game_id: game_id,
          server_id: server_id,
          character_id: character_id,
          code: code,
        },
        header
      )
      .then(response => {
        const data = response.data
        const request = data.data
        if (data.code === 0 || request) {
          commit('GIFTCODE_ADD', request)
          commit('MESSAGE_SUCCESS', 'Nhận giftcode thành công', {
            root: true,
          })
          const vgpid = window.localStorage.getItem('userId')
          // tạo arr rỗng
          const arr = []
          // Tạo obj mỗi lần push
          const obj = {
            id: vgpid,
            data: [
              {
                game_id: game_id,
                server_id: server_id,
                character_id: character_id,
                game_server: window.localStorage.getItem('game_server')
                  ? window.localStorage.getItem('game_server')
                  : '',
                server_group: window.localStorage.getItem('server_group'),
                server_name: window.localStorage.getItem('server_name'),
                character_name: window.localStorage.getItem('character_name'),
                list: JSON.parse(
                  window.localStorage.getItem('server_by_group')
                ),
              },
            ],
          }
          // Check lần đầu tiên lưu local
          const save = window.localStorage.getItem('save')
          if (save === null) {
            // push obj vào arr
            arr.push(obj)
            // lưu vào local
            window.localStorage.setItem('save', JSON.stringify(arr))
          } else {
            const log = JSON.parse(window.localStorage.getItem('save'))
            const map = log.map(v => v.id)
            if (!map.includes(vgpid)) {
              log.push(obj)
              window.localStorage.setItem('save', JSON.stringify(log))
              // Lưu tối đa 10 tài khoản vgp
              if (log.length > 10) {
                // Lớn hơn 10 tài khoản vgp sẽ xóa tài khoản cũ nhất
                log.shift()
                window.localStorage.setItem('save', JSON.stringify(log))
              }
            } else {
              // Nếu trùng vgpid nhưng khác data
              const getUser = log.filter(item => item.id === vgpid)
              const serverName = window.localStorage.getItem('server_name')
              const gameId = window.localStorage.getItem('game_id')
              if (getUser[0] !== undefined) {
                const data = getUser[0].data
                const getData = data.filter(
                  game_id => game_id.game_id === gameId
                )
                if (getData[0] !== undefined) {
                  // Cùng game_id nhưng khác server và nhân vật
                  getData.forEach(element => {
                    if (element.server_name !== serverName) {
                      data.forEach((element, i) => {
                        if (element.game_id === gameId) data[i] = obj.data[0]
                        window.localStorage.setItem('save', JSON.stringify(log))
                      })
                    }
                  })
                } else {
                  // Nếu khác game_id
                  data.push(obj.data[0])
                  window.localStorage.setItem('save', JSON.stringify(log))
                }
              }
            }
          }
        }
      })
      .catch(err => {
        const data = err.response.data
        let message = ''
        if (data.message === 'role used') {
          message = 'Người chơi đã sử dụng loại giftcode này!'
        } else if (data.message === 'error card_id') {
          message = 'Mã giftcode không hợp lệ.'
        } else {
          message = data.message
        }
        commit('MESSAGE_ERROR', message, { root: true })
      })
  },
  [GIFTCODE_SHOW]: ({ commit, dispatch }, payload) => {
    const { event_id } = payload
    axios
      .get(SHOW_GIFTCODE_API.replace('{event_id}', event_id), header)
      .then(response => {
        const data = response.data
        const event = data.data
        if (data.code === 0 && event) {
          commit('GIFTCODE_SHOW', event)
        }
      })
      .catch(err => {
        const data = err.response
        let message = ''
        if (data.status === 401 || data.status === 301) {
          dispatch('AUTH_LOGOUT')
          router.push('/login').catch(routerErrror)
          message = 'Vui lòng đăng nhập lại trang web!'
        } else {
          message = data.data
        }
        commit('MESSAGE_ERROR', message, { root: true })
      })
  },
  [GIFTCODE_HISTORY]: ({ commit, dispatch }, payload) => {
    commit('loading_history', true)
    if (!router.currentRoute.params.id) {
      axios
        .get(GIFTCODE_RECEIVED_API, header)
        .then(response => {
          const data = response.data
          const received_giftcode = data.data
          if (data.code === 0 && received_giftcode) {
            const count = received_giftcode.length
            commit('totalCodes', count)
            commit('GIFTCODE_HISTORY', received_giftcode)
            commit('loading_history', false)
          }
        })
        .catch(e => {
          if (e.toString().includes('401')) {
            dispatch('AUTH_LOGOUT')
            router.push('/login')
            commit(
              'MESSAGE_ERROR',
              'Sai token. Vui lòng đăng nhập lại trang web.',
              { root: true }
            )
          }
        })
    } else {
      const { game_id } = payload
      axios
        .get(GAME_HISTORY_API.replace('{game_id}', game_id), header)
        .then(response => {
          const data = response.data
          const received_giftcode = data.data
          if (data.code === 0 && received_giftcode) {
            const count = received_giftcode.length
            commit('totalCodes', count)
            commit('GIFTCODE_HISTORY', received_giftcode)
            commit('loading_history', false)
          }
        })
        .catch(e => {
          if (e.toString().includes('401')) {
            dispatch('AUTH_LOGOUT')
            router.push('/login')
            commit(
              'MESSAGE_ERROR',
              'Sai token. Vui lòng đăng nhập lại trang web.',
              { root: true }
            )
          }
        })
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
